// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__niEiH","infoWrapper":"styles_infoWrapper__8sMof","info":"styles_info__d6EjU","buttonWrapper":"styles_buttonWrapper__s7mUq","buttonClass":"styles_buttonClass__YQL6U"};
module.exports.__checksum = "3e7d27cc6139"